import type { PlatformType } from '@/modules/daren/constants/platform'
import { companyRequest, goodsRequest, marketRequest } from '@/utils/request'
import { GetWeChatSubscriptionQrCodeParams } from '@servicesTypings/companyRequestV3'
import {
    ErpGoodsDetailInfoVo,
    ErpGoodsDetailQueryParam,
    ErpSpuItemParam,
    ErpSpuQueryResult,
    ErpStockInfoQueryParam,
    QuerySkuStockResult,
    SingleItemDetailQueryParam,
    SkuDetailInfoVo,
    QueryAndFilterSkuDetailInfoParam,
    QueryAndFilterSkuDetailInfoResult,
    ShopStockInfoQueryParam,
    ShopSkuStockInfo,
    ErpGoodsCountInfo,
    ErpSpuInfoQueryParam,
    ErpSpuInfoVo,
    ShopManageSpuQueryVo,
    ShopItemSpuVo
} from '@servicesTypings/goodsRequestV3'
import {
    AddForFindDarenParam,
    AddForSelfDarenParam,
    AddressDetailByCompanyParams,
    AddShowDarenUidParam,
    AssignmentDarenParam,
    AddressDefaultParam,
    AuthInfoDto,
    BaseUserInfo,
    BatchEditDarenContactParam,
    BatchEditDarenContactResult,
    BatchUpdateLabelParam,
    BelongToParam,
    BelongToResult,
    BelongUserVo,
    BindingDarenParam,
    BindingShopParam,
    BindingShopResult,
    CheckHasManyBelongParam,
    CheckHasManyBelongResult,
    CheckLidExistsParam,
    CheckLidExistsResult,
    CheckRepeatParamV2,
    CheckRepeatVo,
    CollectionAccountsResult,
    CollectionTaskQueryParam,
    CollectionTaskSubmitParam,
    CollectionTaskVo,
    CompanyDarenConfigVo,
    CompanyDarenStatistics,
    CoverUpdateLabelParam,
    CreateSampleOrderReturnVo,
    CompanySampleConfigVo,
    CreateSampleReturnOrderParam,
    DarenAddParam,
    DarenAllianceProductParam,
    DarenBaseParam,
    DarenCancelOrderParam,
    DarenCategoryVo,
    DarenContactParam,
    DarenContactVo,
    DwFindDarenParam,
    DarenExtensionInfo,
    DarenFansSelectorVo,
    DarenLabelParam,
    DarenListParam,
    DarenPositionParam,
    DarenPositionResult,
    DarenPromoteListParam,
    DarenPromoteListVo,
    DarenPromoteProductListParam,
    DarenPromoteProductListVo,
    DarenPromoteSaveParam,
    DarenReceiveAddressVo,
    DarenRemarkParam,
    DarenRemarkQueryParam,
    DarenRemarkVo,
    DarenSceneStatistics,
    DarenShopProductVo,
    DarenShowBelongResult,
    DarenSimpleVo,
    DarenSpuListVo,
    DarenUserGroupConfigVo,
    DataBaseInfo,
    DwDarenListVo,
    DwDarenParam,
    DwDarenSaleDetailVo,
    DwDarenSaleParam,
    DwDarenSaleTrendVo,
    DwFindDarenListVo,
    DwUserPerformanceParam,
    EditDarenContactParam,
    EditSelfDarenParam,
    ErpDarenListVo,
    ErpDarenParam,
    HotOrderConfig,
    ImportDarenParam,
    ImportDarenResult,
    ImportExcelDarenParam,
    ImportExcelDarenResult,
    ImportExcelSampleOrderParam,
    ImportNaturalConfig,
    LoadSampleReturnOrderInfoParams,
    ManagerGroupResult,
    NaturalImportParam,
    OrderItemDetail,
    OrderItemDetailParam,
    PageAndSort,
    QueryAutoImportNaturalDarenConfigParams,
    QuerySkuByDarenAndProductParam,
    QuerySkuByDarenAndProductVo,
    RemoveDarenParam,
    RemoveDarenResult,
    ReturnOrderItemDetailParam,
    ReturnOrderItemDetailVo,
    SampleOrderAfsInfo,
    SampleOrderBaseParam,
    SampleOrderCancelByDarenParam,
    SampleOrderListParam,
    SampleOrderShareInfoParam,
    SampleOrderShareInfoVo,
    SampleOrderShareParam,
    SampleOrderStatusParam,
    SampleOrderStatusStatisticVo,
    SampleOrderVo,
    SampleReturnOrderDetail,
    SampleReturnOrderListParam,
    SampleReturnOrderVo,
    SampleStatusResultVo,
    SaveIgnoreReleaseParam,
    SceneStatisticsConfigVo,
    SelfDarenResult,
    ShareAndSampleStatistics,
    SimpleDarenListVo,
    SimpleDarenParam,
    LoadReceiveAddressParams,
    SampleDarenInfo,
    SingleAuditSampleOrderParam,
    StatisticsDarenCountParams,
    StatisticsSceneParam,
    SubscribeInfoVo,
    UpdateOrderCommentsParam,
    DarenLabelVo,
    BatchCreateSampleOrderParam,
    BatchCreateOrderResult,
    CheckRepeatForCreateParam,
    QueryCompanyDarenConfigParams,
    QueryDarenExtensionInfoParams,
    QueryParamParams,
    LoadBySampleOrderNoParams,
    GetProgressParams,
    DarenShowParam,
    ViewDarenContactV2Params,
    DarenContactVoV2,
    BatchUpdateLogisticsParam,
    DeleteContactParams,
    SaveContactParam,
    LoadByAddressIdParams,
    DarenOperateLogDto,
    DarenOperateLogInsertParam,
    DarenOptLogParam,
    DarenOptLogCount,
    QueryCategoryTreeByPidParams,
    DarenCategory,
    QueryCategoryTreeBySearchParams,
    QueryFindDarenCategoryListParams,
    SampleLogisticsVo,
    CategorySearchResult,
    DarenNoNeedReturnVo,
    UpdateNoNeedReasonParam,
    BatchUpdateNoNeedReasonParam,
    BatchUpdateOrderCommentsParam,
    DarenPromotePosterCoInfoVo,
    DarenPromotePosterDetailParam,
    DarenPromotePosterSaveParam,
    SampleOrderDetailVo,
    BatchEditRemarkParam,
    DwDarenDeliverDetailVo,
    QueryNoNeedReturnOperateLogParams,
    SampleNoNeedReturnOperateLogVo,
    BatchGetIdentificationCodeParams,
    DarenShowUidVo,
    DeleteAddress2Params,
    SimpleDarenBizVo,
    CheckHasAuthParams,
    DarenItemDetailCommentsParam,
    ShopAccountDto,
    ShopAccountPluginParam,
    ShopAccountParam,
    FansSelectorsV2Params,
    QueryEditableBelongUserParams,
    SaveEditableBelongUserParam,
    HideNaturalDarenConfigVo,
    FindDarenCountVo,
    BaseContactQueryParam,
    BaseContactViewResult
} from '@servicesTypings/marketRequestV3'

/**
 * 达人列表（多平台）
 */
export function queryDarenList(data: DwDarenParam): API.Res<DwDarenListVo[]> {
    return marketRequest.post('/daren/list/platform', { data })
}

/**
 * erp达人列表
 */
export function erpDarenList(data: ErpDarenParam): API.Res<ErpDarenListVo[]> {
    return marketRequest.post('/daren/erpDarenList', { data })
}

/**
 * 达人新增查询
 */
export function darenQueryForAdd(data: DarenAddParam): API.Res<DarenSimpleVo[]> {
    return marketRequest.post('/daren/darenQueryForAdd', { data })
}

/**
 * 手工新增达人
 */
export function manualAddDaren(data: ImportDarenParam[]): API.Res<ImportDarenResult> {
    return marketRequest.post('/daren/manualAddDaren', { data })
}

/**
 * 查看达人联系方式
 */
export function viewDarenContact(params: { id: string; queryType: string }): API.Res<DarenContactVo> {
    return marketRequest.get('/daren/viewDarenContact', { params })
}

/**
 * 认领 or 取消认领
 */
export function belongTo(data: BelongToParam): API.Res<BelongToResult> {
    return marketRequest.post('/daren/belongTo', { data })
}

/**
 * 查询达人插件配置信息
 */
export function queryDarenExtensionInfo(params: QueryDarenExtensionInfoParams): API.Res<DarenExtensionInfo> {
    return marketRequest.get('/daren/plugin/info', { params })
}

/**
 * 达人分析画像选择器
 */
export function fansSelectors(): API.Res<DarenFansSelectorVo[]> {
    return marketRequest.post('/daren/fansSelectors')
}

/**
 * 达人分析画像选择器
 */
export function fansSelectorsV2(params: FansSelectorsV2Params): API.Res<DarenFansSelectorVo[]> {
    return marketRequest.get('/daren/fansSelectorsV2', { params })
}

/**
 * 认领人列表
 */
export function belongUserList(data: DwDarenParam): API.Res<BelongUserVo[]> {
    return marketRequest.post('/daren/belongUserList', { data })
}

/**
 * 达人类目列表
 */
export function categoryList(): API.Res<DarenCategoryVo[]> {
    return marketRequest.post('/daren/categoryList')
}

/**
 * 达人数量统计
 */
export function statisticsDarenCount(params: StatisticsDarenCountParams): API.Res<CompanyDarenStatistics> {
    return marketRequest.get('/daren/statistics', { params })
}

/**
 * 达人场景数量统计
 */
export function darenSceneStatistics(data: StatisticsSceneParam): API.Res<DarenSceneStatistics> {
    return marketRequest.post('/daren/scene/statistics', { data })
}

/**
 * 订阅详情
 */
export function subscribeInfoUsingPOST(): API.Res<SubscribeInfoVo> {
    return marketRequest.post('/daren/subscribe/info')
}

/**
 * 一键导入达人
 */
export function importErpDaren(data: ErpDarenParam): API.Res<string> {
    return marketRequest.post('/daren/importErpDaren', { data })
}

/** 导入结果 */
export interface ImportErpDarenResult {
    taskType: 'importErpDaren'
    taskState: 'wait' | 'end'
    totalQty: number
    successQty: number
    curQty: number
    failQty: number
    curProcess: number
    errorMsg: null
    fictitiousAddNum: null
    needRecalculateProcess: null
    extra: {
        /** 首个导入成功的平台 */
        firstPlatform?: PlatformType
        /** 错误信息，eg： "导入进行中，请勿重复点击" */
        failMessage: string
        failMessageList: {
            msg: string
            code: string
            nickName: string
            type: string
            platform: string
        }[]
        excelUrl?: string
        /**
         * 用于和插件传输数据
         */
        collectionTaskId?: string
        failExcelUrl?: string
    }
}

/** 新增寄样单导入结果 */
export interface ImportSampleOrderResult {
    taskType: 'excelImportSampleOrder'
    taskState: 'wait' | 'end'
    totalQty: number
    successQty: number
    curQty: number
    failQty: number
    curProcess: number
    errorMsg: null
    fictitiousAddNum: null
    needRecalculateProcess: null
    extra: {
        /** 错误信息，eg： "导入进行中，请勿重复点击" */
        failMessage: string
        /** 成功的寄样单号 */
        successOrderNos: any[]
        failExcelUrl?: string
        failMessageList?: any[]
    }
}

/**
 * 获取任务进度
 */
export function getProgress(params: GetProgressParams): API.Res<object> {
    return marketRequest.get('/progress/queryTask', { params })
}

/**
 * 查询达人带货订单趋势图
 */
export function queryDarenSaleOrderTrend(data: DwDarenSaleParam): API.Res<Record<string, DwDarenSaleTrendVo[]>> {
    return marketRequest.post('/daren/querySaleOrderTrend', { data })
}

/**
 * 查询达人直播带货场次明细
 */
export function queryDarenSaleLiveDetail(data: DwDarenSaleParam): API.Res<DwDarenSaleDetailVo[]> {
    return marketRequest.post('/daren/querySaleLiveDetail', { data })
}

/**
 * 查询达人视频带货场次明细
 */
export function queryDarenSaleVideoDetail(data: DwDarenSaleParam): API.Res<DwDarenSaleDetailVo[]> {
    return marketRequest.post('/daren/querySaleVideoDetail', { data })
}

/**
 * 标签列表v2
 */
export function listV2(): API.Res<DarenLabelVo[]> {
    return marketRequest.get('/daren/label/listV2')
}

/**
 * 添加标签
 */
export function addLabelUsingPOST(data: DarenLabelParam): API.Res<boolean> {
    return marketRequest.post('/daren/label/addLabel', { data })
}

/**
 * 删除标签
 */
export function deleteLabelUsingPOST(data: DarenLabelParam): API.Res<boolean> {
    return marketRequest.post('/daren/label/deleteLabel', { data })
}

/**
 * 覆盖商家标签
 */
export function coverUpdateLabelUsingPOST(data: CoverUpdateLabelParam): API.Res<boolean> {
    return marketRequest.post('/daren/label/coverUpdateLabel', { data })
}

/**
 * 批量修改商家标签
 */
export function batchUpdateLabelUsingPOST(data: BatchUpdateLabelParam): API.Res<number> {
    return marketRequest.post('/daren/label/batchUpdateLabel', { data })
}

/**
 * 根据资料编码查询商品信息
 */
export function querySpuByStyleCodesUsingPOST(data: string[]): API.Res<DarenSpuListVo[]> {
    return marketRequest.post('/daren/querySpuByStyleCodes', { data })
}

/**
 * 商家后台采集任务提交
 */
export function collectionTaskSubmitUsingPOST(data: CollectionTaskSubmitParam): API.Res<string> {
    return marketRequest.post('/daren/collectionTaskSubmit', { data })
}

/**
 * 商家后台采集任务查询
 */
export function collectionTaskQueryUsingPOST(data: CollectionTaskQueryParam): API.Res<CollectionTaskVo> {
    return marketRequest.post('/daren/collectionTaskQuery', { data })
}

/**
 * 查询商家设置
 */
export function queryHotOrderLimitUsingGET(): API.Res<HotOrderConfig> {
    return marketRequest.get('/daren/config/queryHotOrderLimit')
}

/**
 * 保存爆单达人配置
 */
export function configSaveUsingPOST(data: HotOrderConfig): API.Res<boolean> {
    return marketRequest.post('/daren/config/saveHotOrderLimit', { data })
}

/**
 * 微信公众号订阅二维码(临时二维码)
 */
export function getWeChatSubscriptionQRCodeUsingGET(params: GetWeChatSubscriptionQrCodeParams): API.Res<string> {
    return companyRequest.get('/wechat/officialAccount/getWeChatSubscriptionQRCode', { params })
}

/**
 * 找达人列表
 */
export function queryFindDarenListUsingPOST(data: DwFindDarenParam): API.Res<DwFindDarenListVo[]> {
    return marketRequest.post('/daren/findDarenList', { data })
}

/**
 * 达人主推类目列表
 */
export function queryFindDarenCategoryList(params: QueryFindDarenCategoryListParams): API.Res<DarenCategoryVo[]> {
    return marketRequest.get('/daren/findDarenCategoryList', { params })
}

/**
 * 保存联系方式
 */
export function saveUsingPOST(data: DarenContactParam): API.Res<boolean> {
    return marketRequest.post('/daren/contact/save', { data })
}

/**
 * 查询达人场景数量统计配置
 */
export function querySceneStatisticsConfig(): API.Res<SceneStatisticsConfigVo> {
    return marketRequest.get('/daren/config/querySceneStatistics')
}

/**
 * 保存达人场景数量统计配置
 */
export function saveSceneStatisticsConfig(data: SceneStatisticsConfigVo): API.Res<boolean> {
    return marketRequest.post('/daren/config/saveSceneStatistics', { data })
}

/**
 * 查询抖音精选联盟商品列表
 */
export function queryShopAllianceProducts(data: DarenAllianceProductParam): API.Res<DarenShopProductVo[]> {
    return marketRequest.post('/daren/promote/queryShopAllianceProducts', { data })
}

/**
 * ERP 经销商品查询
 */
export function queryErpSpuPage(data: ErpSpuItemParam): API.Res<ErpSpuQueryResult[]> {
    return goodsRequest.post('/erpGoods/queryErpSpuPage', { data })
}

/** 获取 ERP 商品 / 店铺商品 统计数量 */
export function queryErpGoodsCount(params: Record<string, any>): API.Res<ErpGoodsCountInfo> {
    return goodsRequest.get('/erpGoods/queryErpGoodsCount', { params })
}

/** ERP 经销商品查询 */
export function queryErpSpuPageForDaren(data: ErpSpuInfoQueryParam): API.Res<ErpSpuInfoVo[]> {
    return goodsRequest.post('/erpGoods/queryErpSpuPageForDaren', { data })
}

/** 店铺商品管理按款列表 */
export function queryShopItemSpuListForDaren(data: ShopManageSpuQueryVo): API.Res<ShopItemSpuVo[]> {
    return goodsRequest.post('/shopManage/queryShopItemSpuListForDaren', { data })
}

/**
 * 保存推广商品并生成推广编号
 */
export function savePromoteProduct(data: DarenPromoteSaveParam): API.Res<string> {
    return marketRequest.post('/daren/promote/savePromoteProduct', { data })
}

/**
 * 查询推广记录
 */
export function queryPromoteList(data: DarenPromoteListParam): API.Res<DarenPromoteListVo[]> {
    return marketRequest.post('/daren/promote/queryPromoteList', { data })
}

/**
 * 查询默认联盟店铺id
 */
export function queryDefaultAllianceShopId(): API.Res<string> {
    return marketRequest.get('/daren/promote/queryDefaultAllianceShopId')
}

/**
 * 推品寄样统计数据
 */
export function darenShareAndSampleStatistics(ids: string[]): API.Res<ShareAndSampleStatistics[]> {
    return marketRequest.post('/daren/darenShareAndSampleStatistics', { data: ids })
}

/**
 * 保存跳转参数
 */
export function saveQueryParamUsingPOST(data: string): API.Res<string> {
    return marketRequest.post('/open/common/saveQueryParam', { data })
}

/**
 * 绑定店铺
 */
export function bindingShopUsingPOST(data: BindingShopParam): API.Res<BindingShopResult> {
    return marketRequest.post('/daren/sampleOrder/bindingShop', { data })
}

/**
 * 更换or绑定达人
 */
export function bindingDarenUsingPOST(data: BindingDarenParam): API.Res<boolean> {
    return marketRequest.post('/daren/sampleOrder/bindingDaren', { data })
}

/**
 * 单个审核样品单
 */
export function singleAuditOrderUsingPOST(data: SingleAuditSampleOrderParam): API.Res<boolean> {
    return marketRequest.post('/daren/sampleOrder/singleAudit', { data })
}

/**
 * 查询跳转参数
 */
export function queryParamUsingGET(params: QueryParamParams): API.Res<string> {
    return marketRequest.get('/open/common/queryParam', { params })
}

/**
 * 收件人信息保存或修改
 */
export function saveAddressUsingPOST(data: DarenReceiveAddressVo): API.Res<boolean> {
    return marketRequest.post('/daren/receive/address/saveAddress', { data })
}

/**
 * 样品订单列表-状态统计信息
 */
export function listStatisticUsingPOST(data: SampleOrderListParam): API.Res<SampleOrderStatusStatisticVo[]> {
    return marketRequest.post('/daren/sampleOrder/listStatistic', { data })
}

/**
 * 查询样品订单列表
 */
export function sampleListUsingPOST(data: SampleOrderListParam): API.Res<SampleOrderVo[]> {
    return marketRequest.post('/daren/sampleOrder/list', { data })
}

/**
 * 样品订单列表-审核通过、拒绝、删除样品单
 */
export function sampleOrderStatusUsingPOST(data: SampleOrderStatusParam): API.Res<SampleStatusResultVo> {
    return marketRequest.post('/daren/sampleOrder/sampleOrderStatus', { data })
}

/**
 * 根据寄样单号查询详情
 */
export function loadBySampleOrderNoUsingGET(params: LoadBySampleOrderNoParams): API.Res<SampleOrderDetailVo> {
    return marketRequest.get('/daren/sampleOrder/loadBySampleOrderNo', { params })
}

/**
 * 查询推广商品列表
 */
export function queryPromoteProductListUsingPOST(
    data: DarenPromoteProductListParam
): API.Res<DarenPromoteProductListVo[]> {
    return marketRequest.post('/daren/promote/queryPromoteProductList', { data })
}

/**
 * 简单达人信息列表接口
 */
export function simpleDarenListUsingPOST(data: SimpleDarenParam): API.Res<SimpleDarenListVo[]> {
    return marketRequest.post('/daren/simpleDarenList', { data })
}

/**
 * 达人昵称和抖音号进行模糊搜索
 */
export function darenQueryForCompanyUsingPOST(data: DarenAddParam): API.Res<DarenSimpleVo[]> {
    return marketRequest.post('/daren/darenQueryForCompany', { data })
}

/**
 * 样品订单列表-创建人下拉框
 */
export function sampleCreatedListUsingPOST(data: PageAndSort): API.Res<BelongUserVo[]> {
    return marketRequest.post('/daren/sampleOrder/sampleCreatedList', { data })
}

/**
 * 样品订单列表-跟进人下拉框
 */
export function sampleDarenBelongListUsingPOST(data: PageAndSort): API.Res<BelongUserVo[]> {
    return marketRequest.post('/daren/sampleOrder/sampleDarenBelongList', { data })
}

/**
 * 达人样品订单商品明细列表-导出
 */
export function darenSampleOrderExportUsingPOST(data: SampleOrderListParam): API.Res<string> {
    return marketRequest.post('/daren/sampleOrder/darenSampleOrderExport', { data })
}

/**
 * 样品订单列表-创建人下拉框
 */
export function sampleAuditUserListUsingPOST(data: PageAndSort): API.Res<BelongUserVo[]> {
    return marketRequest.post('/daren/sampleOrder/sampleAuditUserList', { data })
}

/**
 * 收件人详情列表
 */
export function addressDetailListUsingPOST(data: string[]): API.Res<DarenReceiveAddressVo[]> {
    return marketRequest.post('/daren/receive/address/addressDetailList', { data })
}

/**
 * 样品订单列表-我跟进统计信息
 */
export function listBelongMeStatisticUsingPOST(data: SampleOrderListParam): API.Res<number> {
    return marketRequest.post('/daren/sampleOrder/listBelongMeStatistic', { data })
}

/**
 * 查询退样品单列表
 */
export function returnOrderList(data: SampleReturnOrderListParam): API.Res<SampleReturnOrderVo[]> {
    return marketRequest.post('/daren/sampleOrder/return/orderList', { data })
}

/**
 * 查询退样品单列表状态统计
 */
export function returnOrderListStatistic(data: SampleReturnOrderListParam): API.Res<SampleOrderStatusStatisticVo[]> {
    return marketRequest.post('/daren/sampleOrder/return/listStatistic', { data })
}

/**
 * 取消退样单
 */
export function returnOrderCancel(data: DarenCancelOrderParam): API.Res<boolean> {
    return marketRequest.post('/daren/sampleOrder/return/orderCancel', { data })
}

/**
 * 退样单列表-跟进人下拉框
 */
export function sampleReturnBelongList(data: PageAndSort): API.Res<BelongUserVo[]> {
    return marketRequest.post('/daren/sampleOrder/return/sampleReturnBelongList', { data })
}

/**
 * 退样单列表-创建人下拉框
 */
export function sampleReturnCreated(data: PageAndSort): API.Res<BelongUserVo[]> {
    return marketRequest.post('/daren/sampleOrder/return/sampleReturnCreatedList', { data })
}

/**
 * 修改退样单备注
 */
export function updateReturnOrderComments(data: UpdateOrderCommentsParam): API.Res<boolean> {
    return marketRequest.post('/daren/sampleOrder/return/updateReturnOrderComments', { data })
}

/**
 * 达人新增批量查询
 */
export function darenQueryListForAddUsingPOST(data: DarenListParam): API.Res<DarenSimpleVo[]> {
    return marketRequest.post('/daren/darenQueryListForAdd', { data })
}

/**
 * excel导入我的达人关系
 */
export function excelBelongMeDarenUsingPOST(data: ImportExcelDarenParam): API.Res<ImportExcelDarenResult> {
    return marketRequest.post('/daren/excelBelongMeDaren', { data })
}

/**
 * excel导入达人
 */
export function excelAddDarenUsingPOST(data: ImportExcelDarenParam): API.Res<ImportExcelDarenResult> {
    return marketRequest.post('/daren/excelAddDaren', { data })
}

/**
 * 移除归属自己或公共达人
 */
export function removeDarenBelongMe(data: RemoveDarenParam): API.Res<RemoveDarenResult> {
    return marketRequest.post('/daren/removeDarenBelongMe', { data })
}

/**
 * 达人样品订单商品明细列表
 */
export function darenItemDetailList(data: OrderItemDetailParam): API.Res<OrderItemDetail> {
    return marketRequest.post('/daren/sampleOrder/darenItemDetailList', { data })
}

/** 达人样品订单商品明细列表-导出 */
export function darenItemDetailExport(data: OrderItemDetailParam): API.Res<string> {
    return marketRequest.post('/daren/sampleOrder/darenItemDetailExport', { data })
}

/**
 * 批量添加到忽略释放白名单
 */
export function batchSaveIgnoreWhitelistUsingPOST(data: SaveIgnoreReleaseParam): API.Res<boolean> {
    return marketRequest.post('/daren/batchSaveIgnoreWhitelist', { data })
}

/**
 * 查询给某个达人寄样的指定商品的sku列表
 */
export function querySkuInfoByDarenAndProductUsingPOST(
    data: QuerySkuByDarenAndProductParam
): API.Res<QuerySkuByDarenAndProductVo> {
    return marketRequest.post('/daren/sampleOrder/querySkuInfoByDarenAndProduct', { data })
}

/**
 * excel导入分配达人关系
 */
export function excelAssignmentDarenUsingPOST(data: ImportExcelDarenParam): API.Res<ImportExcelDarenResult> {
    return marketRequest.post('/daren/excelAssignmentDaren', { data })
}

/**
 * 直接分配达人
 */
export function assignmentDarenUsingPOST(data: AssignmentDarenParam): API.Res<boolean> {
    return marketRequest.post('/daren/assignmentDaren', { data })
}

/**
 * 获取用户ERP商品详情
 */
export function queryErpItemDetailInfo(data: ErpGoodsDetailQueryParam): API.Res<ErpGoodsDetailInfoVo> {
    return goodsRequest.post('/erpGoods/queryErpItemDetailInfo', { data })
}

/**
 * 校验是否存在重复申样V2
 */
export function checkHasRepeatV2UsingPOST(data: CheckRepeatParamV2): API.Res<CheckRepeatVo[]> {
    return marketRequest.post('/daren/sampleOrder/checkHasRepeatV2', { data })
}

/**
 * 找达人批量添加认领分配
 */
export function addForFindDarenUsingPOST(data: AddForFindDarenParam): API.Res<ImportDarenResult> {
    return marketRequest.post('/daren/addForFindDaren', { data })
}

/**
 * 添加展示达人uid
 */
export function addShowDarenUidUsingPOST(data: AddShowDarenUidParam): API.Res<boolean> {
    return marketRequest.post('/daren/addShowDarenUid', { data })
}

/**
 * 获取商品sku明细单sku（达人采购）
 */
export function querySingleErpItemSkuInfoListUsingPOST1(
    data: SingleItemDetailQueryParam
): API.Res<ErpGoodsDetailInfoVo[]> {
    return goodsRequest.post('/erpSkuDetail/querySingleErpItemSkuInfoList', { data })
}

/**
 * 获取商品sku明细单sku（达人采购）
 */
export function querySingleItemSkuDetailInfoListUsingPOST1(
    data: SingleItemDetailQueryParam
): API.Res<SkuDetailInfoVo[]> {
    return goodsRequest.post('/erpSkuDetail/querySingleShopItemSkuInfoList', { data })
}

/*
 * 查询商家达人配置
 */
export function queryCompanyDarenConfigUsingGET(params: QueryCompanyDarenConfigParams): API.Res<CompanyDarenConfigVo> {
    return marketRequest.get('/daren/config/queryCompanyDarenConfig', { params })
}

/**
 * 保存商家达人配置
 */
export function saveCompanyDarenConfigUsingPOST(data: CompanyDarenConfigVo): API.Res<boolean> {
    return marketRequest.post('/daren/config/saveCompanyDarenConfig', { data })
}

/**
 * 校验是否有多人认领
 */
export function checkHasManyBelongUsingPOST(data: CheckHasManyBelongParam): API.Res<CheckHasManyBelongResult> {
    return marketRequest.post('/daren/checkHasManyBelong', { data })
}

/**
 * 达人列表-导出
 */
export function exportPlatformDarenListUsingPOST(data: DwDarenParam): API.Res<string> {
    return marketRequest.post('/daren/list/export', { data })
}

/**
 * 验证当前账号对应的权限【不发短信】
 */
export function validateAuthUsingPOST(data: AuthInfoDto): API.Res<boolean> {
    return marketRequest.post('/common/validateAuth', { data })
}

/**
 * 判断商家开户是否已通过短信验证【发短信】
 */
export function checkMerchantIsVerifiedUsingPOST(data: AuthInfoDto, authOptions: any): API.Res<object> {
    return marketRequest.post('/common/verifyAndSms', { data, authOptions })
}

/**
 * 一键导入自然出单达人
 */
export function importNaturalDarenUsingPOST(data: NaturalImportParam): API.Res<string> {
    return marketRequest.post('/daren/importNaturalDaren', { data })
}

/**
 * 自然出单达人列表
 */
export function naturalDarenListUsingPOST(data: PageAndSort): API.Res<ErpDarenListVo[]> {
    return marketRequest.post('/daren/naturalDarenList', { data })
}

/**
 * 用户进入页面位置
 */
export function darenPositionUsingPOST(data: DarenPositionParam): API.Res<DarenPositionResult> {
    return marketRequest.post('/daren/darenPosition', { data })
}

/**
 * 商家达人联系方式采集参数置换
 */
export function queryContactCollectionDarenListUsingPOST(data: string): API.Res<CollectionAccountsResult> {
    return marketRequest.post('/daren/contact/queryContactCollectionDarenList', { data })
}

/**
 * 修改备注
 */
export function updateOrderCommentsUsingPOST(data: UpdateOrderCommentsParam): API.Res<boolean> {
    return marketRequest.post('/daren/sampleOrder/updateOrderComments', { data })
}

/**
 * 校验物流单号是否存在
 */
export function checkLogisticsLidExistsUsingPOST(data: CheckLidExistsParam): API.Res<CheckLidExistsResult> {
    return marketRequest.post('/daren/sampleOrder/return/checkLogisticsLidExists', { data })
}

/**
 * 保存退样单
 */
export function sampleReturnOrderSaveUsingPOST(data: CreateSampleReturnOrderParam): API.Res<CreateSampleOrderReturnVo> {
    return marketRequest.post('/daren/sampleOrder/return/sampleReturnOrderSave', { data })
}

/**
 * 查询退样单详情
 */
export function loadSampleReturnOrderInfoUsingGET(
    params: LoadSampleReturnOrderInfoParams
): API.Res<SampleReturnOrderDetail> {
    return marketRequest.get('/daren/sampleOrder/return/loadSampleReturnOrderInfo', { params })
}

/**
 * 达人退样样品订单商品明细列表
 */
export function darenItemDetailListUsingPOST1(data: ReturnOrderItemDetailParam): API.Res<ReturnOrderItemDetailVo[]> {
    return marketRequest.post('/daren/sampleOrder/return/darenItemDetailList', { data })
}

/**
 * 分享样品单
 */
export function shareSampleOrderUsingPOST(data: SampleOrderShareParam): API.Res<string> {
    return marketRequest.post('/daren/sampleOrder/share', { data })
}

/**
 * 查询样品单分享信息
 */
export function queryShareInfoUsingPOST(data: SampleOrderShareInfoParam): API.Res<SampleOrderShareInfoVo> {
    return marketRequest.post('/daren/sampleOrder/queryShareInfo', { data })
}

/**
 * 批量导入样品单
 */
export function importSampleOrderUsingPOST(data: ImportExcelSampleOrderParam): API.Res<ImportExcelDarenResult> {
    return marketRequest.post('/daren/sampleOrder/importSampleOrder', { data })
}

/**
 * 分享样品单绑定达人信息
 */
export function bindDarenCompanyUsingPOST2(data: DarenBaseParam): API.Res<boolean> {
    return marketRequest.post('/daren/sampleOrder/bindShareDaren', { data })
}

/**
 * 判断当前用户是否已绑定分享达人
 */
export function checkShareDarenBindUsingPOST(data: SampleOrderShareInfoParam): API.Res<boolean> {
    return marketRequest.post('/daren/sampleOrder/checkShareDarenBind', { data })
}

/**
 * 导出退样品单列表
 */
export function exportOrderListUsingPOST(data: SampleReturnOrderListParam): API.Res<string> {
    return marketRequest.post('/daren/sampleOrder/return/exportOrderList', { data })
}

/**
 * 导出员工业绩列表
 */
export function exportUserPerformanceListUsingPOST(data: DwUserPerformanceParam): API.Res<string> {
    return marketRequest.post('/daren/performance/exportUserPerformanceList', { data })
}

/**
 * 查询无联系方式的任务id
 */
export function queryNoContractTaskIdUsingGET(params: any): API.Res<any> {
    return marketRequest.get('/daren/queryNoContractTaskId', { params })
}

/**
 * 编辑联系方式
 */
export function editContactUsingPOST(data: EditDarenContactParam): API.Res<boolean> {
    return marketRequest.post('/daren/contact/editContact', { data })
}

/**
 * 达人端取消样品单单
 */
export function sampleCancelByDarenUsingPOST(data: SampleOrderCancelByDarenParam): API.Res<SampleStatusResultVo> {
    return marketRequest.post('/daren/creator/sampleOrder/sampleCancelByDaren', { data })
}

/**
 * 通过ERP订单生成样品单
 */
export function importErpOrderUsingPOST(data: ImportExcelSampleOrderParam): API.Res<ImportExcelDarenResult> {
    return marketRequest.post('/daren/sampleOrder/importErpOrder', { data })
}

/**
 * 查询Erp库存
 */
export function queryErpItemStockInfo(data: ErpStockInfoQueryParam): API.Res<QuerySkuStockResult[]> {
    return goodsRequest.post('/erpGoods/queryErpItemStockInfo', { data })
}

/**
 * 批量编辑联系方式
 */
export function batchEditSelfContactUsingPOST(data: BatchEditDarenContactParam): API.Res<BatchEditDarenContactResult> {
    return marketRequest.post('/daren/contact/batchEditSelfContact', { data })
}

/**
 * 查询当前用户所拥有的分组关系
 */
export function queryUserGroup(): API.Res<ManagerGroupResult> {
    return marketRequest.get('/daren/common/queryUserGroup')
}

/**
 * 收件人详情-公司达人
 */
export function addressDetailByCompany(params: AddressDetailByCompanyParams): API.Res<DarenReceiveAddressVo[]> {
    return marketRequest.get('/daren/receive/address/addressDetailByCompany', { params })
}

/**
 * 查询数据智能付费信息
 */
export function queryDataPayInfoUsingGET(): API.Res<DataBaseInfo> {
    return marketRequest.get('/daren/subscribe/queryDataPayInfo')
}

/**
 * 查询达人配置分组下的用户列表
 */
export function configUserListUsingGET(): API.Res<BaseUserInfo[]> {
    return marketRequest.get('/daren/common/configUserList')
}

/**
 * 保存用户设置达人分组配置
 */
export function saveUserDarenGroupConfigUsingPOST(data: DarenUserGroupConfigVo): API.Res<boolean> {
    return marketRequest.post('/daren/config/saveUserDarenGroupConfig', { data })
}

/**
 * 查询用户设置达人分组配置
 */
export function queryUserDarenGroupConfigUsingGET(): API.Res<DarenUserGroupConfigVo> {
    return marketRequest.get('/daren/config/queryUserDarenGroupConfig')
}

/**
 * 自建达人添加认领分配
 */
export function addForSelfDaren(data: AddForSelfDarenParam): API.Res<SelfDarenResult> {
    return marketRequest.post('/daren/addForSelfDaren', { data })
}

/**
 * 查询自动导入自然出单达人多平台配置
 */
export function queryAutoImportNaturalDarenConfig(
    params: QueryAutoImportNaturalDarenConfigParams
): API.Res<ImportNaturalConfig[]> {
    return marketRequest.get('/daren/config/queryAutoImportNaturalDarenConfig', { params })
}

/**
 * 保存自动导入自然出单达人多平台配置
 */
export function saveAutoImportNaturalDarenConfig(data: ImportNaturalConfig[]): API.Res<Boolean> {
    return marketRequest.post('/daren/config/saveAutoImportNaturalDarenConfig', { data })
}

/**
 * 查询寄样单中未退回样品订单列表
 */
export function queryNotReturnedList(data: SampleOrderListParam): API.Res<SampleOrderVo[]> {
    return marketRequest.post('/daren/sampleOrder/queryNotReturnedList', { data })
}

/**
 * 自建达人修改昵称、平台号
 */
export function editForSelfDaren(data: EditSelfDarenParam): API.Res<Boolean> {
    return marketRequest.post('/daren/editForSelfDaren', { data })
}

/**
 * 根据寄样单号查询地址详情
 */
export function loadReceiveAddress(params: LoadReceiveAddressParams): API.Res<SampleDarenInfo> {
    return marketRequest.get('/daren/sampleOrder/loadReceiveAddress', { params })
}

/**
 * 查询寄样单订单关联的退样单信息
 */
export function orderAboutAfsList(data: SampleOrderBaseParam): API.Res<SampleOrderAfsInfo[]> {
    return marketRequest.post('/daren/sampleOrder/orderAboutAfsList', { data })
}

/**
 * 备注信息保存或修改
 */
export function saveRemark(data: DarenRemarkParam): API.Res<Boolean> {
    return marketRequest.post('/daren/remark/saveRemark', { data })
}

/**
 * 查询备注列表
 */
export function queryRemarks(data: DarenRemarkQueryParam): API.Res<DarenRemarkVo[]> {
    return marketRequest.post('/daren/remark/queryRemarks', { data })
}

/**
 * 检查达人是否归属自己是否可见
 */
export function checkDarenShowBelongFlag(data: DarenShowParam[]): API.Res<DarenShowBelongResult[]> {
    return marketRequest.post('/daren/checkDarenShowBelongFlag', { data })
}

/**
 * 查看联系方式
 */
export function viewDarenContactV2(params: ViewDarenContactV2Params): API.Res<DarenContactVoV2> {
    return marketRequest.get('/daren/contact/viewDarenContactV2', { params })
}

/**
 * 删除联系方式
 */
export function deleteContact(params: DeleteContactParams): API.Res<Boolean> {
    return marketRequest.get('/daren/contact/deleteContact', { params })
}

/**
 * 保存联系方式V2
 */
export function saveV2(data: SaveContactParam): API.Res<Boolean> {
    return marketRequest.post('/daren/contact/saveV2', { data })
}

/**
 * 批量新增联系方式
 */
export function batchEditSelfContactV2(data: BatchEditDarenContactParam): API.Res<BatchEditDarenContactResult> {
    return marketRequest.post('/daren/contact/batchEditSelfContactV2', { data })
}

/**
 * 删除寄样地址
 */
export function deleteAddress(params: DeleteAddress2Params): API.Res<Boolean> {
    return marketRequest.get('/daren/receive/address/deleteAddress', { params })
}

/**
 * 查询达人/分销商收件人详情
 */
export function loadByAddressId(params: LoadByAddressIdParams): API.Res<DarenReceiveAddressVo> {
    return marketRequest.get('/daren/receive/address/loadByAddressId', { params })
}

/**
 * 保存/更新寄样单
 */
export function sampleOrderSaveV3(data: BatchCreateSampleOrderParam): API.Res<BatchCreateOrderResult> {
    return marketRequest.post('/daren/sampleOrder/saveV3', { data })
}

/** 按达人尺码标签批量查询店铺商品中符合达人尺码的 SKU */
export function queryAndFilterShopSkuDetailInfo(
    data: QueryAndFilterSkuDetailInfoParam[]
): API.Res<QueryAndFilterSkuDetailInfoResult[]> {
    return goodsRequest.post('/erpSkuDetail/queryAndFilterShopSkuDetailInfo', { data })
}

/** 按达人尺码标签批量查询基础资料商品中符合达人尺码的 SKU */
export function queryAndFilterErpSkuDetailInfo(
    data: QueryAndFilterSkuDetailInfoParam[]
): API.Res<QueryAndFilterSkuDetailInfoResult[]> {
    return goodsRequest.post('/erpSkuDetail/queryAndFilterErpSkuDetailInfo', { data })
}

/** 在创建订单时校验是否存在重复申样 */
export function checkHasRepeatForCreate(data: CheckRepeatForCreateParam): API.Res<CheckRepeatVo[]> {
    return marketRequest.post('/daren/sampleOrder/checkHasRepeatForCreate', { data })
}

/**
 * 修改备注
 */
export function batchUpdateOrderComments(data: BatchUpdateOrderCommentsParam): API.Res<SampleStatusResultVo[]> {
    return marketRequest.post('/daren/sampleOrder/batchUpdateOrderComments', { data })
}

/**
 * 批量修改备注以及附件
 */
export function batchUpdateReturnOrderComments(data: BatchUpdateOrderCommentsParam): API.Res<SampleStatusResultVo> {
    return marketRequest.post('/daren/sampleOrder/return/batchUpdateOrderComments', { data })
}

/**
 * 批量导入退样单
 */
export function importSampleOrder(data: ImportExcelSampleOrderParam): API.Res<ImportExcelDarenResult> {
    return marketRequest.post('/daren/sampleOrder/return/importSampleOrder', { data })
}

/**
 * 查询达人操作日志记录表列表
 */
export function queryDarenOptionLogList(data: object): API.Res<DarenOperateLogDto> {
    return marketRequest.post('/daren/optLog/queryDarenOptionLogList', { data })
}

/**
 * 添加达人操作日志记录表
 */
export function insertAndUpdate(data: DarenOperateLogInsertParam): API.Res<Boolean> {
    return marketRequest.post('/daren/optLog/insertAndUpdate', { data })
}

/**
 * 查询达人操作日志记录数量
 */
export function countDarenOptionCount(data: DarenOptLogParam): API.Res<DarenOptLogCount[]> {
    return marketRequest.post('/daren/optLog/countDarenOptionCount', { data })
}

/**
 * 删除达人操作日志记录表
 */
export function deleteOptLog(data: string[]): API.Res<Boolean> {
    return marketRequest.post('/daren/optLog/deleteOptLog', { data })
}

/**
 * 导出所有已寄样的商品信息
 */
export function exportSentSampleOrderDetailList(data: object): API.Res<string> {
    return marketRequest.post('/daren/exportSentSampleOrderDetailList', { data })
}

/**
 * 查询商家寄样配置
 */
export function queryCompanySampleConfig(): API.Res<CompanySampleConfigVo> {
    return marketRequest.get('/daren/config/queryCompanySampleConfig')
}

/**
 * 保存商家寄样配置
 */
export function saveCompanySampleConfig(data: CompanySampleConfigVo): API.Res<Boolean> {
    return marketRequest.post('/daren/config/saveCompanySampleConfig', { data })
}

/** 查询无需退样原因 */
export function queryNoNeedReturnReasonList(): API.Res<DarenNoNeedReturnVo[]> {
    return marketRequest.get('/daren/config/queryNoNeedReturnReasonList')
}

/** 保存无需退样原因 */
export function saveNoNeedReturnReason(data: DarenNoNeedReturnVo): API.Res<Boolean> {
    return marketRequest.post('/daren/config/saveNoNeedReturnReason', { data })
}

/** 删除无需退样原因 */
export function deleteNoNeedReturnReason(data: DarenNoNeedReturnVo): API.Res<Boolean> {
    return marketRequest.post('/daren/config/deleteNoNeedReturnReason', { data })
}

/**
 * 批量设置快递信息
 */
export function batchUpdateLogistics(data: BatchUpdateLogisticsParam): API.Res<SampleStatusResultVo> {
    return marketRequest.post('/daren/sampleOrder/batchUpdateLogistics', { data })
}

/**
 * 查询启用的快递列表
 */
export function queryEnabledLogistics(): API.Res<SampleLogisticsVo[]> {
    return marketRequest.get('/common/queryEnabledLogistics')
}

/** 单个编辑无需退样原因 */
export function updateNoNeedReturnReason(data: UpdateNoNeedReasonParam): API.Res<Boolean> {
    return marketRequest.post('/daren/sampleOrder/updateNoNeedReturnReason', { data })
}

/** 批量编辑无需退样原因 */
export function batchUpdateNoNeedReason(data: BatchUpdateNoNeedReasonParam): API.Res<SampleStatusResultVo> {
    return marketRequest.post('/daren/sampleOrder/batchUpdateNoNeedReturnReason', { data })
}

/** 查询无需退样操作日志 */
export function queryNoNeedReturnOperateLog(
    params: QueryNoNeedReturnOperateLogParams
): API.Res<SampleNoNeedReturnOperateLogVo> {
    return marketRequest.get('/daren/sampleOrder/queryNoNeedReturnOperateLog', { params })
}

/**
 * 查询店铺商品库存
 */
export function queryShopItemStockInfo(data: ShopStockInfoQueryParam): API.Res<ShopSkuStockInfo[]> {
    return goodsRequest.post('/shopItemDetail/queryShopItemStockInfo', { data })
}

/**
 * 根据父级类目ID获取子类目列表
 */
export function queryCategoryTreeByPid(params: QueryCategoryTreeByPidParams): API.Res<DarenCategory[]> {
    return marketRequest.get('/daren/queryCategoryTreeByPid', { params })
}

/**
 * 根据搜索关键词获取子类目列表
 */
export function queryCategoryTreeBySearch(params: QueryCategoryTreeBySearchParams): API.Res<CategorySearchResult[]> {
    return marketRequest.get('/daren/queryCategoryTreeBySearch', { params })
}

/**
 * 商家-查询商家实力详情
 */
export function queryCoInfo(): API.Res<DarenPromotePosterCoInfoVo> {
    return marketRequest.get('/daren/promote/queryCoInfo')
}

/**
 * 商家-查询海报商品详情
 */
export function queryPromoteProductInfo(data: DarenPromotePosterDetailParam): API.Res<DarenPromoteProductListVo[]> {
    return marketRequest.post('/daren/promote/queryPromoteProductInfo', { data })
}

/**
 * 商家-保存海报配置
 */
export function savePosterConfig(data: DarenPromotePosterSaveParam): API.Res<void> {
    return marketRequest.post('/daren/promote/savePosterConfig', { data })
}

/**
 * 优化版简单达人信息列表接口
 */
export function simpleDarenListIncludeDict(data: SimpleDarenParam): API.Res<SimpleDarenListVo[]> {
    return marketRequest.post('/daren/simpleDarenListIncludeDict', { data })
}

/**
 * 批量修改备注
 */
export function batchEditRemark(data: BatchEditRemarkParam): API.Res<Boolean> {
    return marketRequest.post('/daren/remark/batchEditRemark', { data })
}

/**
 * 账单采集-查询店铺账号密码列表
 */
export function queryShopAccountsByPlatform(data: ShopAccountPluginParam): API.Res<ShopAccountDto[]> {
    return marketRequest.post('/shop/account/queryShopAccountsByPlatform', { data })
}

/**
 * 达人退样样品订单商品明细添加备注/图片
 */
export function updateDarenItemDetailComments(data: DarenItemDetailCommentsParam): API.Res<Boolean> {
    return marketRequest.post('/daren/sampleOrder/return/updateDarenItemDetailComments', { data })
}

/**
 * 账单采集-保存店铺账号密码列表
 */
export function saveOrUpdateShopAccount(data: ShopAccountParam): API.Res<void> {
    return marketRequest.post('/shop/account/saveOrUpdateShopAccount', { data })
}

/**
 * 查询达人带货交付明细数据
 */
export function queryDarenDeliverDetail(data: DwDarenSaleParam): API.Res<DwDarenDeliverDetailVo[]> {
    return marketRequest.post('/daren/queryDarenDeliverDetail', { data })
}

/**
 * 查询当前达人是否可见平台uid
 */
export function queryShowDarenUidList(darenIdList: string[]): API.Res<DarenShowUidVo[]> {
    return marketRequest.post('/daren/queryShowDarenUidList', { data: darenIdList })
}

/**
 * 批量获取仓库识别码
 */
export function batchGetIdentificationCode(params: BatchGetIdentificationCodeParams): API.Res<string[]> {
    return marketRequest.get('/daren/sampleOrder/return/batchGetIdentificationCode', { params })
}

/**
 * 查询达人数据
 */
export function queryDarenBizDataInfo(data: string[]): API.Res<SimpleDarenBizVo[]> {
    return marketRequest.post('/daren/data/queryDarenBizDataInfo', { data })
}

/**
 * 查询达人是否有权限
 */
export function checkHasAuth(params: CheckHasAuthParams): API.Res<Boolean> {
    return marketRequest.get('/daren/auth/checkHasAuth', { params })
}

/**
 * 修改达人默认收件人地址
 */
export function updateDefaultAddress(data: AddressDefaultParam): API.Res<Boolean> {
    return marketRequest.post('/daren/receive/address/updateDefaultAddress', { data })
}

/**
 * 查询寄样单可修改的跟进人
 */
export function queryEditableBelongUser(params: QueryEditableBelongUserParams): API.Res<BelongUserVo[]> {
    return marketRequest.get('/daren/sampleOrder/queryEditableBelongUser', { params })
}

/**
 * 保存寄样单修改后的跟进人
 */
export function saveEditableBelongUser(data: SaveEditableBelongUserParam): API.Res<Boolean> {
    return marketRequest.post('/daren/sampleOrder/saveEditableBelongUser', { data })
}

/**
 * 查询隐藏自然出单达人配置
 */
export function queryHideNaturalDarenConfig(): API.Res<HideNaturalDarenConfigVo> {
    return marketRequest.get('/daren/config/queryHideNaturalDarenConfig')
}

/**
 * 保存隐藏自然出单达人配置
 */
export function saveHideNaturalDarenConfig(data: HideNaturalDarenConfigVo): API.Res<Boolean> {
    return marketRequest.post('/daren/config/saveHideNaturalDarenConfig', { data })
}

/**
 * 找达人总数
 */
export function findDarenCount(): API.Res<FindDarenCountVo> {
    return marketRequest.get('/daren/findDarenCount')
}

/**
 * 查看公开联系方式
 */
export function viewBaseContact(data: BaseContactQueryParam): API.Res<BaseContactViewResult> {
    return marketRequest.post('/daren/contact/viewBaseContact', { data })
}
